import List from 'components/List'
import InternalLink from 'components/InternalLink'

const Suggestion = ({ item, handleLinkClick }) => (
  <li>
    <InternalLink
      to={`/${item.type}/${item.pk}?device=${item.deviceId}`}
      onClick={handleLinkClick}
    >
      {item.name}
    </InternalLink>
  </li>
)

const Suggestions = ({ suggestions, handleLinkClick, customer }) => {
  let suggestionList

  // @hack : hardcoded for demo purposes
  if (customer === 'unionwireless-stagingca') {
    suggestions = [
      {
        pk: 1685465,
        type: 'faq',
        deviceId: 25204,
        name: 'FAQ: How do I get a carrier unlock code?'
      }
    ]
  }

  // @hack : hardcoded for demo purposes
  if (customer === 'att') {
    suggestionList = [
      <li>
        <InternalLink
          to="#"
          onClick={() =>
            window.postMessage({ type: 'dbOpenBot', module: 'No Picture' }, '*')
          }
        >
          No Picture Workflow
        </InternalLink>
      </li>
    ]
  } else if (suggestions.length === 0) {
    return null
  } else {
    suggestionList = suggestions.map((suggestion) => (
      <Suggestion
        key={suggestion.pk}
        item={suggestion}
        handleLinkClick={handleLinkClick}
      />
    ))
  }

  return (
    <div>
      <hr />
      <List title="Suggestions: ">{suggestionList}</List>
    </div>
  )
}

export default Suggestions
